const getApiConfig = (queryClient, mfeConfig, enabled, additionalQueryOptions) => {
    return {
        config: mfeConfig,
        queryOptions: {
            ...queryClient.getQueryDefaults(),
            ...additionalQueryOptions,
            enabled
        }
    };
};
export default getApiConfig;
